import {
    Box,
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import DownloadIcon from "@mui/icons-material/Download";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import Transactions from "../../Modals/transactions";

const ServiceProviderEarnings = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
 const handleCloseModal = () => {
    setOpen(false);
  };

    const rows = [
        {
            id: 1,
            salonName: "Glamour Cuts",
            email: "glamourcuts@gmail.com",
            bookings: 120,
            earnings: "AED 12,000",
            pendingPayout: "AED 3,000",
        },
        {
            id: 2,
            salonName: "Elite Barber Shop",
            email: "elitebarber@gmail.com",
            bookings: 85,
            earnings: "AED 8,500",
            pendingPayout: "AED 1,200",
        },
    ];

    return (
        <>
            <div className="table_header">
                <div className="left_s">
                    <Box className="search_box">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search..."
                        />
                    </Box>
                    <Box className="form">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                className="form_control"
                                slots={{
                                    openPickerIcon: () => (
                                        <img src="/static/images/date_icon.svg" alt="icon" />
                                    ),
                                }}
                                slotProps={{
                                    textField: {
                                        placeholder: "Select Date",
                                        fullWidth: true,
                                        hiddenLabel: true,
                                    },
                                }}
                                desktopModeMediaQuery="(min-width:0px)"
                            />
                        </LocalizationProvider>
                    </Box>
                </div>
                <div className="right_s">
                    <Button className="btn btn_primary">
                        <DownloadIcon /> Export
                    </Button>
                </div>
            </div>

            <TableContainer className="table_container">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Service Provider Details</TableCell>
                            <TableCell>No. of Bookings</TableCell>
                            <TableCell>Total Earnings</TableCell>
                            <TableCell>Pending Payout Amount</TableCell>
                            <TableCell>Pay</TableCell>
                            <TableCell>Transaction History</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow hover key={row.id}>
                                {/* Service Provider (Salon) details */}
                                <TableCell>
                                    <div
                                        className="user_block click_action"
                                        onClick={() => navigate("/manage-service-providers/view")}
                                    >
                                        <figure>
                                            <img
                                                src="/static/images/user_placeholder.png"
                                                alt=""
                                                width={40}
                                            />
                                        </figure>
                                        <p>
                                            <b>{row.salonName}</b>
                                            <span>{row.email}</span>
                                        </p>
                                    </div>
                                </TableCell>

                                {/* No. of Bookings */}
                                <TableCell>{row.bookings}</TableCell>

                                {/* Total Earnings */}
                                <TableCell>{row.earnings}</TableCell>

                                {/* Pending Payout */}
                                <TableCell>{row.pendingPayout}</TableCell>

                                {/* Pay Button */}
                                <TableCell>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        color="primary"
                                        onClick={() => alert(`Paying ${row.pendingPayout} to ${row.salonName}`)}
                                    >
                                        Pay
                                    </Button>
                                </TableCell>

                                {/* Action Buttons */}
                                <TableCell>
                                    <div className="table_actions v2">
                                        <Box>
                                            <Tooltip title="View User Details" arrow>
                                                <IconButton onClick={() => setOpen(true)}
                                                    >
                                                    <img src="/static/images/eye_icon.svg" alt="View" />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
             <Transactions open={open} onClose={handleCloseModal} setOpen={setOpen}  />
        </>
    );
};

export default ServiceProviderEarnings;
